import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { PlusAlt } from '@bnnvara/icons/src/components/UserInterfaceIcons/PlusAlt';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import withHtmlSafe from '@bnnvara/typography/src/components/withHtmlSafe';
import theme from '@bnnvara/themes';

import * as S from './styled';

const AccordionDetailsContainer = withHtmlSafe(AccordionDetails);

export const AccordionItem = ({ item }) => {
  const [expanded, setExpanded] = useState(item.expanded);
  const primaryColors = theme.bnnvara.colors.primary;

  const handleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <S.AccordionItem>
      <Accordion expanded={expanded} onChange={handleExpanded}>
        <AccordionSummary expandIcon={<PlusAlt fill={primaryColors.main} />}>
          <S.Summary>{item.subject}</S.Summary>
        </AccordionSummary>
        <AccordionDetailsContainer
          html
          allowedTags={[
            'p',
            'a',
            'ul',
            'li',
            'strong',
            'b',
            'em',
            'i',
            'u',
            'br',
          ]}
        >
          {item.description}
        </AccordionDetailsContainer>
      </Accordion>
    </S.AccordionItem>
  );
};

AccordionItem.propTypes = {
  item: PropTypes.shape({
    subject: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    expanded: PropTypes.bool,
  }),
};

AccordionItem.defaultProps = {
  item: {
    expanded: false,
  },
};
